module.exports = __webpack_public_path__ + "fonts/Blinker-Bold.98d21a1.ttf";